import {
  COMPONENT_VALUE_TYPES as types
} from 'shared/constants';

/*
this function generates empty default props from propsSchema
    const schemaProps = [
      {
        key: 'array',
        type: 'ARRAY',
      },
      {
        key: 'text',
        type: 'TEXT',
      },
    ]

    ->

    {
      array: [],
      text: ''
    }
*/
export default function getEmptyDefaultProps(propsSchema) {
  const result = {};

  propsSchema.forEach(x => {
    switch (x.type) {
      case types.BOOLEAN:
        result[x.key] = false;
        break;
      case types.TEXT:
        result[x.key] = '';
        break;
      case types.TEXTAREA:
        result[x.key] = '';
        break;
      case types.ARRAY:
        result[x.key] = [];
        break;
      case types.OBJECT:
        result[x.key] = getEmptyDefaultProps(x.children);
        break;
      default:
        result[x.key] = undefined;
        break;
    }
  });

  return result;
}
